import React, { Component } from "react";
import Chart from "react-apexcharts/dist/react-apexcharts.cjs.js";
import { useState } from "react";
const Ploatchart=(props)=>{
  console.log(props.series, "seris");

  const options = {
    chart: {
      type: 'area'
    },
    xaxis: {
      type: 'month',
      categories: ["Januray", "February", "March", "April", "May", "June","July","August","September","Octuber","November","December"]
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth'
    },
    
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm'
      },
    },
  };
  
   /*  const [state,setstate]=useState(
        {
          
          
            series: props.series,
            options:  {
              chart: {
                type: 'area'
              },
              xaxis: {
                type: 'month',
                categories: ["Januray", "February", "March", "April", "May", "June","July","August","September","Octuber","November","December"]
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'smooth'
              },
              
              tooltip: {
                x: {
                  format: 'dd/MM/yy HH:mm'
                },
              },
            },
          
          
          }


    ); */

    //setstate()

    
    return(<>
    <div>

    <Chart
    options={options} 
    series={props.series} 
    type='area'

   />
    </div>
    </>)
}
export default Ploatchart;

